import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, InputNumber, Switch, Tabs, Card, AutoComplete } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, formatNumber, formatDate, dayjsDate, getobjkeys, getyhzh, checkp } from '../../utils/functions'
import renderFileList from "../../components/renderFileList";
import ShEditor from "../../components/ShEditor";
import ExpenditureDetails from "../cwb/ExpenditureDetails";
import CustModal from "../../components/ShowModal";
import InvoiceDetails from "../cwb/InvoiceDetails";
import ImgUploader from "../../components/ImgUploader";

const { Option } = Select;
function Xxpsh() {
    const { type } = useParams();
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [bgsItem, setbgsItem] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(30);
    const [activeKey, setActiveKey] = useState('0');

    const [yhzh, setYhzh] = useState(null);
    const [form] = Form.useForm();
    const pageSizeOptions = [10, 20, 50, 100, 500];
    const [kmdata, setKmdata] = useState(null);
    const [invoiceLy, setInvoiceLy] = useState(null);
    const [editingRecord, setEditingRecord] = useState(null);
    const [flcount, setflcount] = useState(1);
    const [shResult, setShResult] = useState({});
    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = async () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            let res = [], tos = 0;
            try {
                const params = { type, s: activeKey, page: currentPage, limit: pageSize };
                const response = await webPost('xxpshb', params);
                if (response) {
                    res = response;
                    tos = response.length;
                }
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
            setData(res);
            setTotal(tos);
        }
        fetchItems();
    }, [currentPage, pageSize, filters, freshData, activeKey, type]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 80, fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '项目名称', dataIndex: 'xmmc' },
        { title: '制单人', dataIndex: 'maker_name' },
        { title: '制单日期', dataIndex: 'make_date' },
        { title: '含税金额', dataIndex: 'amount' },
        { title: '开票税率', dataIndex: 'kpsl' },
        { title: '付款户名', dataIndex: 'payer_name' },
        { title: '买方单位名称', dataIndex: 'mf_dw' },

        (checkp(['cwfp1']) || checkp(['cwfp2'])) && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => <Button type="link" onClick={() => showModal(record, "scbs")} >开始审核</Button>,
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (!record) {
            message.error("错误的参数");
            return;
        }
        if (yhzh === null) {
            const res1 = await getyhzh(webPost);
            setYhzh(res1);
        }
        if (kmdata === null) {
            const kms = await webPost('cktypelist', {});
            if (kms) setKmdata(kms);
        }
        const fldata = await webPost('getInvoiceLy', { 'invoice_id': record.id });

        setInvoiceLy(fldata.ly);
        setEditingRecord({ ...record, flps: fldata?.flps, coms:fldata?.coms  });
        setModalVisible(action);
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
        setInvoiceLy(null);
    }
    const saveSuccess = async (r) => {
        if (!editingRecord?.id) return message.error("错误的参数");
        if (Number(editingRecord?.shstep) === 2) {
            if (r.result === -1) {
                const params = { id: editingRecord.id, step: 2, ...r, sn: editingRecord.sn };
                const res = await webPost('xxpshbsave', params);
                if (res) {
                    message.success('审核成功');
                    setfreshData(Math.random()); //强制刷新数据
                    handleModalClose();
                    setflcount(1);
                }
                return;
            }
            setLoading(true);
            setShResult(r);
            setModalVisible('fl');
            if (yhzh === null) {
                const res1 = await getyhzh(webPost);
                setYhzh(res1);
            }
            if (kmdata === null) {
                const kms = await webPost('cktypelist', {});
                if (kms) setKmdata(kms);
            }
            setLoading(false);

            const kms = [];
            const amtFields = [];
            const amtValues = [];
            const kmmcFields = [];
            const kmmcValues = [];

            const calcAmt = (baseAmount, percent) => {
                return ((baseAmount || 0) * percent / 100).toFixed(2);
            };

            const baseAmount = editingRecord.amount || 0;
            const kpslKey = editingRecord.kpsl;

            // 1. 检查 CK034
            const fVal = editingRecord.flps?.['f' + kpslKey];
            if (fVal > 0) {
                kms.push('CK034');
                amtFields.push(`amt0`);
                amtValues.push(calcAmt(baseAmount, fVal));
                kmmcFields.push(`kmmc0`);
                kmmcValues.push('待缴纳税金');
            }

            // 2. 检查 CK027-0
            const glfVal = editingRecord.flps?.['glf' + kpslKey];
            if (glfVal > 0) {
                const idx = kms.length;
                kms.push('CK027-0');
                amtFields.push(`amt${idx}`);
                amtValues.push(calcAmt(baseAmount, glfVal));
                kmmcFields.push(`kmmc${idx}`);
                kmmcValues.push('管理服务费');
            }

            // 3. 检查 CK012-1
            const yglfVal = editingRecord.flps?.['yglf' + kpslKey];
            if (yglfVal > 0) {
                const idx = kms.length;
                kms.push('CK012-1');
                amtFields.push(`amt${idx}`);
                amtValues.push(calcAmt(baseAmount, yglfVal));
                kmmcFields.push(`kmmc${idx}`);
                kmmcValues.push('税/管费差额');
            }

            // 确保至少有一个分流
            const finalCount = Math.max(kms.length, 1);
            setflcount(finalCount);

            // 组装表单初始值对象
            const initialValues = {};
            kms.forEach((km, i) => {
                initialValues[`km${i}`] = km;
                initialValues[amtFields[i]] = amtValues[i];
                initialValues[kmmcFields[i]] = kmmcValues[i];
            });

            // 批量赋值给表单
            form.setFieldsValue(initialValues);
        } else {
            const params = { id: editingRecord.id, step: 1, s: activeKey, ...r, sn: editingRecord.sn };
            const res = await webPost('xxpshbsave', params);
            if (res) {
                message.success('审核成功');
                setfreshData(Math.random()); //强制刷新数据
                handleModalClose();
                setflcount(1);
            }
        }
    };
    const saveSubmit = async () => {
        const values = await form.validateFields();
        let total = 0;
        for (let i = 0; i < flcount; i++) {
            total += Number(values[`amt${i}`]) || 0;
        }
        if (Math.abs(total - editingRecord.amount_sj) >= 0.01) {
            message.error('支出金额合计与应收税款不符');
            return;
        }

        const params = { id: editingRecord.id, step: 2, ...shResult, ...values, sn: editingRecord.sn, xmmc: editingRecord.xmmc, flcount };
        console.log(params);
        const res = await webPost('xxpshbsave', params);
        if (res) {
            message.success('审核成功');
            setfreshData(Math.random()); //强制刷新数据
            handleModalClose();
        }
    }
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    const [skey, setSkey] = useState('');
    const [options, setOptions] = useState([]);
    const searchXm = async (i) => {
        const res = await webPost('getXmmcBykey', { skey });
        if (res) {
            const newops = [...options];
            newops[i] = res;
            setOptions(newops);
            form.setFieldValue(`xmmc${i}`, res[0]?.xmmc);
            form.setFieldValue(`sn${i}`, res[0]?.sn);
        }
    }
    const setXmsn = (v, i) => {
        const currentOptions = options[i] || [];
        for (const it of currentOptions) {
            const matchStr = `${it.sn}……${it.xmmc}`;
            if (v === matchStr) {
                console.log(it);
                form.setFieldsValue({
                    [`sn${i}`]: it.sn, [`xmmc${i}`]: it.xmmc
                });
                break;
            }
        }
    };
    const setInvoicePay = (v, i) => {
        const invoice_ly = invoiceLy.find((it) => Number(v) === Number(it.id));
        if (invoice_ly) {
            form.setFieldValue(`pay_bank_id${i}`, invoice_ly.bank_id);
            // form.setFieldValue(`amt${i}`, invoice_ly.amount);
        } else {

        }
    }

    return (
        <FullHeightLayout
            isloading={loading}
            headerContent={null}
            bodyContent={
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey={(record, index) => index}
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 1800,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                    />
                </>
            }
            footerContent={<div style={{
                display: 'flex', justifyContent: 'flex-end',
                alignItems: 'center',
            }}>
                <CustModal
                    title={'审核结果'}
                    open={modalVisible === 'scbs'}
                    onCancel={handleModalClose}
                    okText="保存"
                    cancelText="取消"
                    footer={null}
                >
                    <ShEditor onChange={saveSuccess}>
                        <InvoiceDetails detailData={editingRecord} lyData={invoiceLy} />
                        <div>审核备注1：{editingRecord?.remark1 || '无'}</div>
                    </ShEditor>
                </CustModal>
                <CustModal
                    title={'资金分流明细'}
                    open={modalVisible === 'fl'}
                    onCancel={handleModalClose}
                    onOk={saveSubmit}
                    okText="保存审核结果"
                    cancelText="取消"
                    isloading={loading}
                >
                    <Form form={form} layout="vertical">
                        {
                            <Card key={`jsdj`} title="税金信息">
                                {/* <Form.Item name={`pay_bank_id_swj`} label="选择支付账户" placeholder="选择支付账户">
                                <Select>{yhzh && yhzh.map(it => {
                                    return <Option key={it.id} value={it.id}>{`${it.dw}-${it.mc}-${it.zh}`}</Option>
                                })}</Select>
                            </Form.Item>
                            <Form.Item name={`swj_money`} label="支付金额"><InputNumber /></Form.Item> */}
                                <div className="responsive-grid4">
                                    <Form.Item label="含税金额">{editingRecord?.amount}</Form.Item>
                                    <Form.Item label="开票税率">{editingRecord?.kpsl}%</Form.Item>
                                    <Form.Item label="应收税率">{editingRecord?.yssl}%</Form.Item>
                                    <Form.Item label="应收税款">{editingRecord?.amount_sj}</Form.Item>
                                </div>
                                <div>填报企业：{editingRecord?.coms}</div>
                                <div>税费备注：{editingRecord?.flps?.ps2}</div>
                            </Card>
                        }
                        {
                            Array.from({ length: flcount }, (_, index) => (
                                <Card key={`fl_${index}`} title={`分流${1 + index}`}>
                                    <div className="responsive-grid4">
                                        <Form.Item label="费用科目" name={`km${index}`}>
                                            <Select
                                                showSearch
                                                placeholder="输入科目代码或名称进行搜索"
                                                optionFilterProp="label"
                                                filterOption={(input, option) => {
                                                    const inputLower = input.toLowerCase();
                                                    const km = option.km?.toString().toLowerCase() || '';
                                                    const kmmc = option.kmmc?.toLowerCase() || '';
                                                    return km.includes(inputLower) || kmmc.includes(inputLower);
                                                }}
                                                onChange={(value) => {
                                                    const matched = kmdata.find(it => it.km === value);
                                                    if (matched) {
                                                        form.setFieldsValue({ [`kmmc${index}`]: matched.kmmc });
                                                    }
                                                    console.log(value, editingRecord?.flps);
                                                    switch (value) {
                                                        case 'CK034':
                                                            if (editingRecord?.flps?.['f' + editingRecord?.kpsl] > 0) {
                                                                form.setFieldsValue({
                                                                    [`amt${index}`]:
                                                                    ((editingRecord?.amount || 0) * editingRecord?.flps?.['f' + editingRecord?.kpsl] / 100).toFixed(2)
                                                                });
                                                            }
                                                            break;
                                                        case 'CK027-0':
                                                            if (editingRecord?.flps?.['glf' + editingRecord?.kpsl] > 0) {
                                                                form.setFieldsValue({
                                                                    [`amt${index}`]:
                                                                    ((editingRecord?.amount || 0) * editingRecord?.flps?.['glf' + editingRecord?.kpsl] / 100).toFixed(2)
                                                                });
                                                            }
                                                            break;
                                                        case 'CK012-1':
                                                            if (editingRecord?.flps?.['yglf' + editingRecord?.kpsl] > 0) {
                                                                form.setFieldsValue({
                                                                    [`amt${index}`]:
                                                                    ((editingRecord?.amount || 0) * editingRecord?.flps?.['yglf' + editingRecord?.kpsl] / 100).toFixed(2)
                                                                });
                                                            }
                                                            break;
                                                    }
                                                }}
                                            >
                                                {kmdata && kmdata?.map((item) => (
                                                    <Select.Option
                                                        key={`${item.id}-${item.km}`}
                                                        value={item.km}
                                                        km={item.km}
                                                        kmmc={item.kmmc}
                                                        label={`${item.km} ${item.kmmc}`}
                                                    >
                                                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                                            <span>{item.km}</span>
                                                            <span style={{ color: '#666', fontSize: '12px' }}>{item.kmmc}</span>
                                                        </Space>
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item name={`zfly_${index}`} label="支付来源">
                                            <Select onChange={(v) => setInvoicePay(v, index)}>{invoiceLy && invoiceLy.map(it => {
                                                return <Option key={it.id} value={it.id}>{it.cw_data_id === 0 ? (it.type === '资金垫付' ? '资金垫付' : '现付') : it.zfly}</Option>
                                            })}</Select>
                                        </Form.Item>
                                        <Form.Item name={`pay_bank_id${index}`} label="支付账户" placeholder="支付账户">
                                            <Select>{yhzh && yhzh.map(it => {
                                                return <Option key={it.id} value={it.id}>{`${it.dw}-${it.mc}-${it.zh}`}</Option>
                                            })}</Select>
                                        </Form.Item>
                                        <Form.Item label="支付金额" name={`amt${index}`}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item hidden name={`kmmc${index}`}><Input /></Form.Item>

                                    </div>
                                    <div>
                                        <Form.Item label="项目搜索">
                                            <Space size='middle'>
                                                <Input onChange={(e) => { setSkey(e.target.value) }} placeholder="输入项目编号或项目名称" />
                                                <Button onClick={() => { searchXm(index) }} >搜索</Button>
                                            </Space>
                                        </Form.Item>
                                    </div>
                                    <div className="responsive-grid2">
                                        <Form.Item hidden name={`sn${index}`}><Input /></Form.Item>
                                        <Form.Item hidden name={`xmmc${index}`}><Input /></Form.Item>
                                        <Form.Item label="项目名称" name={`snxmmc${index}`}>
                                            <AutoComplete options={options[index] && options[index].map(it => ({ value: `${it.sn}……${it.xmmc}` }))}
                                                onChange={(v) => { setXmsn(v, index) }} />
                                        </Form.Item>

                                        <Form.Item name={`bank_id_${index}`} label="选择转入账户">
                                            <Select placeholder="选择转入账户">{yhzh && yhzh.map(it => {
                                                return <Option key={it.id} value={it.id}>{`${it.dw}-${it.mc}-${it.zh}`}</Option>
                                            })}</Select>
                                        </Form.Item>
                                    </div>
                                </Card>
                            ))
                        }
                        <Form.Item label={<a onClick={() => { setflcount(prev => (1 + prev)); }}>增加分流列表</a>} ></Form.Item>
                        <Card key={`wjz`} title={`外经证`}>
                            <div className="responsive-grid2">
                                <Form.Item label="外经证" name="files2"><ImgUploader /></Form.Item>
                                <Form.Item label="反馈表" name="files3"><ImgUploader /></Form.Item>
                            </div>
                        </Card>
                        <Card key={`wszm`} title={`完税证明`}>
                            <div className="responsive-grid2">
                                <Form.Item label="预缴增值税" name="files4"><ImgUploader /></Form.Item>
                                <Form.Item label="预缴企业所得税" name="files5"><ImgUploader /></Form.Item>
                                <Form.Item label="其它税额" name="files6"><ImgUploader /></Form.Item>
                                <Form.Item label="个人所得税" name="files7"><ImgUploader /></Form.Item>
                            </div>
                        </Card>
                        <Card key={`wsfp`} title={`发票`}>
                            <div className="responsive-grid2">
                                <Form.Item label="发票" name="files8"><ImgUploader /></Form.Item>
                            </div>
                        </Card>
                    </Form>
                </CustModal>
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                    onChange={onPageChange}
                    pageSizeOptions={pageSizeOptions}
                />
            </div>}
        />
    )
}


export default Xxpsh;
